import React, { Component } from 'react';
import { connect } from 'react-redux';
import HowMembershipWorks from './HowMembershipWorks.jsx';
import { navigate } from '../modules/high_level_actions';

class AboutUs extends Component {
  constructor(props){
    super(props);
  }

  render() {
    let title = (<div />),
        subtitle = (<div />),
        books = this.props.tla === "DVD" ? 'DVDs' : "books";
    if( this.props.type ==="Neglite")
      title = ( <h2>Welcome to the {this.props.name}</h2>),
      subtitle = (<h4 dangerouslySetInnerHTML={{__html: this.props.hiw_subtitle}} />);

    return (
      <div className="content-max-width cms hiw-wrapper">
        <div className="content-max-width ">
          <a href="/" className="button btn-secondary float-right" onClick={(evt) => this.props.dispatch(navigate(evt))}>Continue shopping</a>
        </div>
        <div className="modal-body">
          <div className="inner-wrapper">
            {title}
            {subtitle}
            <HowMembershipWorks  />
            <a href="/" className="button btn-secondary" onClick={(evt) => this.props.dispatch(navigate(evt))}>Sounds great! Let's get started</a>
            <p>Read our <a href="/terms-of-use" onClick={(evt) => this.props.dispatch(navigate(evt))}>Terms & Conditions</a> to learn more about your membership.</p>
            <p>{ this.props.store_bundle_pricing ? "*Pre-orders are not eligible for free shipping." : "*Free shipping is only eligible on orders of 3 or more " + books + " with a total cart balance of $35+. Pre-orders are not eligible for free shipping. "}</p>
          </div>
        </div>
      </div>
    );
  }
};

function mapStateToProps(state){
    return {
      'type': state.store.type,
      'name': state.store.name,
      'tla': state.store.tla,
      'store_bundle_pricing': state.store.bundle_pricing,
      'hiw_subtitle': state.store.hiw_subtitle
    };
}

export default connect(mapStateToProps)(AboutUs);



// WEBPACK FOOTER //
// ./src/components/CmsHowItWorks.jsx